import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { PointsDisplayIcon } from 'ui-system/components/points-display';

import { HIGHLIGHT_COLOR } from '../constants';

import {
  PointsText as DefaultPointsText,
  RewardDescription as DefaultRewardDescription,
  StyledPointsDisplay as DefaultStyledPointsDisplay,
  StyledPointsIcon as DefaultStyledPointsIcon,
  StyledProgressMeter as DefaultStyledProgressMeter,
} from './incentive-details.styled.default';

export * from './incentive-details.styled.default';

export const StyledPointsIcon = styled(DefaultStyledPointsIcon)`
  transform: scale(1.4);

  path {
    fill: ${Styles.color.white};
  }
`;

export const PointsText = styled(DefaultPointsText)`
  margin: 0.5rem;
  background: ${Styles.color.contrastBackground};
  color: ${Styles.color.white};
`;

export const StyledProgressMeter = styled(DefaultStyledProgressMeter)`
  background: ${Styles.color.grey.ten};

  & > div {
    background: ${HIGHLIGHT_COLOR};
  }
`;

export const RewardDescription = styled(DefaultRewardDescription)`
  color: ${Styles.color.black};
`;

export const RemoveRewardsButton = styled(ActionButton)`
  width: 14.5rem;
  height: 2rem;
  font-size: 0.813rem;
  border: 2px solid ${Styles.color.primary};
  line-height: 0.813rem;
  padding: 0.5rem 1rem;
  text-transform: capitalize;
  margin: 0 auto;
`;
export const StyledPointsDisplay = styled(DefaultStyledPointsDisplay)`
  ${PointsDisplayIcon} path {
    fill: currentColor;
  }
`;
